import { cn } from '../cn';

export interface ColorSwatchProps {
  color: string;
  selected?: boolean;
  onClick?: () => void;
  label?: string;
  className?: string;
}

/** 28 × 28, radius 6; selected = 2 px accent ring, else 1 px border2. */
export function ColorSwatch({ color, selected, onClick, label, className }: ColorSwatchProps) {
  return (
    <button
      type="button"
      aria-label={label ?? color}
      aria-pressed={!!selected}
      onClick={onClick}
      className={cn('h-7 w-7 rounded p-0', selected ? 'border-2 border-accent' : 'border border-border2', className)}
      style={{ background: color }}
    />
  );
}

/** Wide colour bar (boot colour): 12 px tall, radius 6, border2. */
export function ColorBar({ color, className }: { color: string; className?: string }) {
  return <div className={cn('h-3 w-full rounded border border-border2', className)} style={{ background: color }} />;
}

export const CAPTION_SWATCHES = [
  { label: 'White', hex: '#FFFFFF' },
  { label: 'Yellow', hex: '#FFE14D' },
  { label: 'Cyan', hex: '#7CE7FF' },
] as const;
